import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import Sidebar from "../../../../partials/aside/Sidebar";
import categoryUserSitePublisherAction from "../../../../../store/actions/categoryUserSitePublisher";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import helpersNumbers from "../../../../../helpers/numbers";
import typeActionCategoryUserSitePublisher from "../../../../../store/actions/typeActionCategoryUserSitePublisher";

function AllIndependentPositionsSitePublisher({
  startDate,
  endDate,
  dataSitePublisher,
  addPositionTagToState,
  position_added_in_edit_action,
  addedPositionInEditAction,
  typeAction,
  render,
}) {
  const params = useParams();
  const sitePublisherID = parseInt(params.id);
  const pageID = 0;
  const pageTitle = process.env.REACT_APP_TITLE_INDEPENDENT_PAGE;
  const [positions, setPositions] = useState([]);
  const [imageSrc, setImageSrc] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();
  const history = useHistory();

  useEffect(() => {
    const initDataComponent = async () => {
      await getSitePublisher();
      await getImageIndependentSitePublisher();
      await getIndependentPositions();
    };
    initDataComponent();
  }, []);

  const getImageIndependentSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const image = await sendRequestGetImageIndependentPositionsSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!image) {
      return;
    }

    setImageSrc(image.src);
  };

  const sendRequestGetImageIndependentPositionsSitePublisher = async (
    sitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let image;
    try {
      image = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/image-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return image.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitePublisher) {
      return;
    }
    setSitePublisherData(sitePublisher);
  };

  const sendRequestGetSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const getIndependentPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const independentPositions = await sendRequestGetIndependentPositions(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!independentPositions) {
      return;
    }

    setPositions(independentPositions);
  };

  const sendRequestGetIndependentPositions = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let independentPositions;
    try {
      independentPositions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/all-independent-positions/alternative/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return independentPositions.data.data;
  };

  const hasPositionEmptyCampaignBanner = (position) => {
    const newPendingCampaigns =
      getCampaignBannerThatOverrideCampaignDateWithDateGroup(position);
    if (position.count > newPendingCampaigns.length) {
      return true;
    }

    return false;
  };

  const getCampaignBannerThatOverrideCampaignDateWithDateGroup = (position) => {
    const startDateGroup = helpersTime.convertJalaliToGregorian(startDate);
    const endDateGroup = helpersTime.convertJalaliToGregorian(endDate);
    const newCampaigns = [];
    let pendingAlternativeCampaigns = position.pending_alternative;
    for (const key in pendingAlternativeCampaigns) {
      const pendingAlternativeCampaign = pendingAlternativeCampaigns[key];
      const startDateCampaign = pendingAlternativeCampaign.start_date;
      const endDateCampaign = pendingAlternativeCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingAlternativeCampaign);
      }
    }

    let activeAlternativeCampaigns = position.active_alternative;
    for (const key in activeAlternativeCampaigns) {
      const activeAlternativeCampaign = activeAlternativeCampaigns[key];
      const startDateCampaign = activeAlternativeCampaign.start_date;
      const endDateCampaign = activeAlternativeCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(activeAlternativeCampaign);
      }
    }

    return newCampaigns;
  };

  const generateCheckBoxAddPositionTag = (
    position,
    isChecked,
    addPositionToState
  ) => {
    if (
      isChecked === "checked" &&
      typeAction === typeActionCategoryUserSitePublisher.EDIT &&
      !position_added_in_edit_action.includes(position.tag_html_id)
    ) {
      return;
    }
    return (
      <label className="adl-switch">
        <input
          type="checkbox"
          defaultChecked={isChecked}
          onChange={(e) => {
            addPositionToState(position);
          }}
        />
        <span className="adl-slider round"></span>
      </label>
    );
  };

  const addPositionToState = (position) => {
    const positionsPriceAlternative = position.price_alternative;

    addPositionTagToState({
      site_publisher_url: sitePublisherData.url.replace("http://", ""),
      web_site_publisher_id: sitePublisherID,
      page_id: pageID,
      page_title: pageTitle,
      position_tag_html_id: position.tag_html_id,
      position_price: positionsPriceAlternative,
    });

    if (typeAction === typeActionCategoryUserSitePublisher.EDIT) {
      addedPositionInEditAction({
        position: position.tag_html_id,
      });
    }
  };

  const generatePositionsPageSitePublisher = () => {
    return positions.map((position, index) => {
      const isPositionEmptyCampaignBanner =
        hasPositionEmptyCampaignBanner(position);

      let isChecked = "";

      if (dataSitePublisher[sitePublisherID] !== undefined) {
        if (dataSitePublisher[sitePublisherID][pageID] !== undefined) {
          if (
            dataSitePublisher[sitePublisherID][pageID].positions.includes(
              position.tag_html_id
            )
          ) {
            isChecked = "checked";
          }
        }
      }

      let classBgPosition = "";
      if (isPositionEmptyCampaignBanner) {
        if (isChecked === "checked") {
          classBgPosition = "bg-primary";
        }
      } else {
        classBgPosition = "bg-danger";
      }

      return (
        <div
          key={index}
          className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
        >
          <div className={classBgPosition}>
            <div className="p-2 d-flex">
              <div className="position-absolute">
                <span>
                  {isPositionEmptyCampaignBanner === true ? (
                    generateCheckBoxAddPositionTag(
                      position,
                      isChecked,
                      addPositionToState
                    )
                  ) : (
                    <></>
                  )}
                </span>
              </div>
              <div className="align-items-center justify-content-center d-flex flex-grow-1 letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(position.size)}
              </div>
            </div>

            <div className="px-2 d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                {helpersNumbers.toPersianNum(` ${position.count} / 1`)}
              </div>
              <div className="py-2 w-50 text-center letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  Math.floor((1 / position.count) * 100)
                )}
                %
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ جایگاه در حالت جایگزین :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    position.price_alternative
                  )
                )}
              </span>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ پایه جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(position.base_price)
                )}
              </span>
            </div>
            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(position.price)
                )}
              </span>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    });
  };

  const checkDataExisiForcalculateAmountThisPage = () => {
    if (pageID === undefined) {
      return false;
    }

    if (sitePublisherData === undefined) {
      return false;
    }

    if (positions.length === 0) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID] === undefined) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID][pageID] === undefined) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID][pageID].positions.length === 0) {
      return false;
    }
    return true;
  };

  const getPricePage = () => {
    if (!checkDataExisiForcalculateAmountThisPage()) {
      return 0;
    }
    return dataSitePublisher[sitePublisherID][pageID].price;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span>
                    جایگاه های مستقل سایت {"  "}
                    {sitePublisherData?.url.replace("http://", "")}
                  </span>
                  <span className="pr-2">
                    <a target="_blank" className="text-white"></a>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="form-group">
                <div>
                  <img className="img-fluid" src={imageSrc} />
                </div>
              </div>
              <div className="px-2">
                <div className="alert alert-info">
                  <span className="pl-2">
                    <i className="fa fa-info"></i>
                  </span>
                  <span>
                    جایگاه های قرمز به معنای رزور شدن توسط کمپین کاربران است.
                  </span>
                </div>
              </div>

              <div className="px-2">
                <span>مبلغ این صفحه =</span>
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(getPricePage())
                  )}
                </span>
                <span className="pr-2">تومان</span>
              </div>

              <div className="container-fluid" id="select-position-container">
                <div className="row">
                  {positions.length !== 0 ? (
                    generatePositionsPageSitePublisher(positions)
                  ) : (
                    <></>
                  )}
                </div>
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                  }}
                  className="btn btn-primary"
                  to={`/manage/publishers/alternative/${sitePublisherID}/all-page`}
                >
                  ذخیره و بازگشت
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addPositionTagToState: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_POSITION,
        payload: action,
      });
    },
    addPriceToPage: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_PRICE_TO_PAGE,
        payload: action,
      });
    },
    addedPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.POSITION_ADDED_IN_EDIT_ACTION,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    typeAction: state.categoryUserSitePublisher.type_action,
    position_added_in_edit_action:
      state.categoryUserSitePublisher.position_added_in_edit_action,
    render: state.categoryUserSitePublisher.render,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllIndependentPositionsSitePublisher);
